import { useEffect } from "react";
import { AgentAnnotationOverlays } from "@/components/cursors/agent-annotation-overlay";
import { invalidateMovedAnnotations } from "@/lib/invalidate-moved-annotations";
import { isTauri } from "@/lib/is-tauri";
import { useCanvasStore } from "@/stores/canvas-store";
import { useProjectStore } from "@/stores/project-store";
import { listenWhileMounted } from "./tauri-listener-cleanup";

/** Emitted by the companion once an agent step moved what is on screen: a
 * scroll on one display, or a page key or page change for the execution. */
const AGENT_VIEW_MOVED_EVENT = "denker://agent-view-moved";

/** Screen drawings belong to the desktop, independently of which chat or
 * avatar is selected and whether the canvas is currently visible. */
export function DesktopAgentAnnotationLayer() {
  const cursors = useCanvasStore((state) => state.agentCursors);
  const projectId = useProjectStore((state) => state.currentProject?.id);
  const spaceId = useProjectStore((state) => state.currentSpace?.id);

  useEffect(() => {
    if (!isTauri()) return;
    return listenWhileMounted<{
      executionId: string;
      displayId?: number | null;
      since: number;
    }>(AGENT_VIEW_MOVED_EVENT, ({ payload }) =>
      invalidateMovedAnnotations(
        payload.displayId != null
          ? { displayId: payload.displayId }
          : { executionId: payload.executionId },
        payload.since,
      ),
    );
  }, []);

  return (
    <>
      {[...cursors.values()].map((cursor) => {
        if (
          cursor.projectId
            ? cursor.projectId !== projectId
            : spaceId && cursor.spaceId !== spaceId
        )
          return null;
        if (
          !cursor.annotationTarget &&
          !cursor.annotationTargets?.length &&
          !cursor.presentationDeliveryId
        )
          return null;
        return (
          <AgentAnnotationOverlays
            key={cursor.agentId}
            cursor={cursor}
            variant="compact"
            standalone
          />
        );
      })}
    </>
  );
}
